var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"absolute":"","opacity":0.4}},[_c('v-progress-circular',{attrs:{"size":40,"width":4,"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }